import { FC, PropsWithChildren, ReactNode } from "react"
import { useNavigate } from "react-router-dom"

type PropType = FC<PropsWithChildren<{
  title: ReactNode
  items: (string | {href: string, text: string} | ReactNode)[]
}>>

const MessageBlock: PropType = ({title, items}) => {
  const navigator = useNavigate()

  return (
    <div className="font-18 line-height-1-8">
      <div className='font-700 font-20'>{title}</div>
      {
        items.map((row: any, index) => (
          <div key={index}>
            { typeof row === 'string' ? row : row.href ? <span className={row.href ? 'cursor-pointer link-line' : ''} onClick={() => navigator(row.href)}>{row.text}</span> : row}
          </div>
        ))
      }
      
    </div>
  )
}

export default MessageBlock
